import axios from "axios";
import { useEffect, useState } from "react";

const GetLeadStatusData = ({onStatusChange, selectedStatus, totalLeads, leadStatusCount}) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);

    const handleStatusCLick = (status) => {
        const newStatus = selectedStatus === status ? null : status;
        onStatusChange(newStatus);
    };
    return(
        <div className="bg-white flex flex-col item-start shadow-lg rounded-lg p-3 md:p-4 mb-4 w-full h-fit">
            <h1 className="font-bold text-base md:text-lg mb-2">Your Total Leads ({totalLeads})</h1>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4">
                <div 
                    onClick={() => handleStatusCLick('Active')}
                    className={`bg-gray-100 rounded-lg p-3 md:p-4 min-h-[80px] flex flex-col md:flex-row justify-between md:items-center cursor-pointer transition-all ${
                        selectedStatus === 'Active' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200 active:bg-gray-300`}
                    role="button"
                    tabIndex={0}>
                    <div className="mb-2 md:mb-0">
                        <h3 className="font-bold text-sm md:text-base">Active</h3>
                        <span className="text-xs md:text-sm text-gray-600">last 7 days</span>
                    </div>
                    <span className="text-lg md:text-xl font-bold self-end md:self-auto">{leadStatusCount.find(item => item.lead_status === 'Active')?.count || "0"}</span>
                </div>

                <div 
                    onClick={() => handleStatusCLick('Ongoing')}
                    className={`bg-gray-100 rounded-lg p-3 md:p-4 min-h-[80px] flex flex-col md:flex-row justify-between md:items-center cursor-pointer transition-all ${
                        selectedStatus === 'Ongoing' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200 active:bg-gray-300`}
                    role="button"
                    tabIndex={0}>
                    <div className="mb-2 md:mb-0">
                        <h3 className="font-bold text-sm md:text-base">Ongoing</h3>
                        <span className="text-xs md:text-sm text-gray-600">last 40 days</span>
                    </div>
                    <span className="text-lg md:text-xl font-bold self-end md:self-auto">{leadStatusCount.find(item => item.lead_status === 'Ongoing')?.count || "0"}</span>
                </div>

                <div 
                    onClick={() => handleStatusCLick('Inactive')}
                    className={`bg-gray-100 rounded-lg p-3 md:p-4 min-h-[80px] flex flex-col md:flex-row justify-between md:items-center cursor-pointer transition-all ${
                        selectedStatus === 'Inactive' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200 active:bg-gray-300`}
                    role="button"
                    tabIndex={0}>
                    <div className="mb-2 md:mb-0">
                        <h3 className="font-bold text-sm md:text-base">Inactive</h3>
                        <span className="text-xs md:text-sm text-gray-600">&gt; 40 days</span>
                    </div>
                    <span className="text-lg md:text-xl font-bold self-end md:self-auto">{leadStatusCount.find(item => item.lead_status === 'Inactive')?.count || "0"}</span>
                </div>

                <div 
                    onClick={() => handleStatusCLick('Tanked')}
                    className={`bg-gray-100 rounded-lg p-3 md:p-4 min-h-[80px] flex flex-col md:flex-row justify-between md:items-center cursor-pointer transition-all ${
                        selectedStatus === 'Tanked' ? "ring-2 ring-blue-500" : ""
                    } hover:bg-gray-200 active:bg-gray-300`}
                    role="button"
                    tabIndex={0}>
                    <div className="mb-2 md:mb-0">
                        <h3 className="font-bold text-sm md:text-base">Tanked</h3>
                        <span className="text-xs md:text-sm text-gray-600">&gt; 90 days</span>
                    </div>
                    <span className="text-lg md:text-xl font-bold self-end md:self-auto">{leadStatusCount.find(item => item.lead_status === 'Tanked')?.count || "0"}</span>
                </div>
            </div>
        </div>
    )
}

export default GetLeadStatusData;